<div class="flex flex-row justify-start w-full gap-6">
<div [formGroup]="committeeForm" class="w-full">
  <label class="mb-2 body-large-bold" for="Committee-Input" id = "Committee-Label">
    Committee
  </label>
  <mat-form-field appearance="outline" class="relative w-full mt-1" id="Committee-Field">
    <input type="text"
           id="Committee-Input"
           placeholder="Enter the committee title or code"
           aria-label="Number"
           matInput
           formControlName="committeeCtrl"
           [matAutocomplete]="committeeAuto"
           (input)="handleCommitteeInputChange($event)"
           (focus)="loadingCommitteeOptions()">
    <span class="material-symbols-rounded -ml-9">
      arrow_drop_down
    </span>
    <mat-autocomplete #committeeAuto="matAutocomplete" class="bg-white">
      <mat-option *ngFor="let option of filteredCommitteeOptions | async" [value]="option.value" class="bg-white" (click)= "committeeSelected(option.value)" id="Committee-Option">
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
</div>

<div class="flex flex-col gap-6 p-5 bg-white rounded-md shadow-xl">
  <div class="flex items-center w-full gap-2">
    <label class="body-default-bold" for="CommitteeDesignation" id="Committee-Code-Label">
      Committee Code
    </label>
    <label class="body-default-regular" id="Committee-Code-Value">
      {{committee?.committeeCode}}
    </label>
  </div>

  <div class="flex items-center w-full gap-2">
    <label class="body-default-bold" for="CommitteeDesignation" id="Committee-Name-Label">
      Committee Name
    </label>
    <label class="body-default-regular" id="Committee-Name-Value" >
      {{committee?.committeeName}}
    </label>
  </div>

  <div class="flex items-center w-full gap-2">
    <label class="body-default-bold" for="CommitteeDesignation" id="Project-Manager-Label">
      Lead
    </label>
    <label class="body-default-regular" id="Project-Manager-Value" >
      {{committee?.committeeProjectManagerName}}
    </label>
  </div>

  <div class="w-full">
      <label class="body-default-regular" for="OptionsForMembersToVote" id="Options-For-Members-To-Vote-Label">
        Options for members to vote:
      </label>
      <ul class="pl-5 text-sm list-disc">
        @for (voteOption of voteOptions; track voteOption) {
        <li id={{voteOption}}>{{voteOption}}</li>
        }
      </ul>

  </div>

</div>

